import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { formatFileSize } from '../../util';


class UploadPreviewThumb extends React.Component {

	constructor(props) {
		super(props);
		this.preview = React.createRef();

		this.state = {
			isImage: props.file.type.match('image.*') ? true : false,
			loading: false,
			dataUrl: ''
		}
	}

	componentDidMount() {
		if(!this.state.isImage) return;
		this.setState({loading: true});
		const reader = new FileReader();
		reader.onload = ((dis) => {
			return (e) => {
				dis.setState({dataUrl: e.target.result});
			}
		})(this);
		reader.readAsDataURL(this.props.file);
	}

	render() {
		if(this.state.isImage) {
			return (<div className="upload-preview" style={{backgroundImage: `url(${this.state.dataUrl})`}} ref={this.preview}></div>);
		} else {
			return (<div className="upload-preview"><FontAwesomeIcon icon="sticky-note" size="2x" /></div>);
		}
	}
}


class UploadPreviewItem extends React.Component {
    render() {
        const { file } = this.props;
        return (<div className="upload-file">
                <button onClick={() => this.props.handleRemove(file.key)}><FontAwesomeIcon icon="trash" /></button>
                <UploadPreviewThumb file={file} />
                {file.name}
                <div className="meta" style={{marginTop:'0.25rem'}}>{formatFileSize(file.size)}</div>
        </div>);
    }
}

class UploadPreview extends React.Component {
	render() {
		return (
            <React.Fragment>
                {this.props.files.map(file => <UploadPreviewItem file={file} key={file.key} handleRemove={this.props.handleRemove} />)}
			</React.Fragment>
		)
	}
}


export default UploadPreview


// WEBPACK FOOTER //
// ./src/components/upload/UploadPreview.js